<app-carousel [options]="options" [select]="_scrollTo">
  <div
    #image
    class="position-relative"
    *ngFor="let image of product.images; let index = index; let first = first"
  >
    <div
      class="image w-100 h-100"
      [ngClass]="{
        first: first,
        nopad:
          product.product_type.includes('Leather Sleeve') ||
          product.title.includes('Smiley Cup') ||
          product.tags.includes('nopad')
      }"
    >
      <img
        fill
        *ngIf="_sleeve?.images && first"
        class="sleeve"
        sizes="(max-width: 991px) 100vw, 50vw"
        [ngSrc]="
          product.title.includes('Grande')
            ? _sleeve.images[0]
            : _sleeve.images[0]
        "
      />
      <img
        class="hero w-100 h-auto"
        [width]="760"
        height="720"
        [ngSrc]="image.src"
        [priority]="first"
        [loaderParams]="{ aspect: 1 }"
        sizes="(max-width: 991px) 100vw, 50vw"
      />
    </div>
  </div>
</app-carousel>
<div class="thumbs mx-3 d-flex flex-row">
  <div
    class="thumb"
    [ngClass]="{ active: currentIndex === index }"
    (click)="scrollTo(index)"
    *ngFor="let image of product.images; let index = index; let first = first"
  >
    <img
      width="46"
      [ngStyle]="{
        backgroundColor: first
          ? 'none'
          : product.metafields?.product?.image_background_colour ??
            'rgba(0,0,0,.05)'
      }"
      height="46"
      sizes="10vw"
      [ngSrc]="image.src"
    />
  </div>
</div>
